import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@eatclubapp/ec-component-library';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loading from '../loading/Loading';
import useStyles from './ForecastingHeaderStyles';
import MobileHeader from '../MobileHeader/MobileHeader';

const ForecastingHeader = ({
  children,
  navigationOpen = false,
  disableDrawerMargin = false,
  disableDrawerMarginOnMdDown = false,
  showMobileHeader = false,
}) => {
  const classes = useStyles({
    navigationOpen,
    disableDrawerMargin,
    disableDrawerMarginOnMdDown,
  });

  return (
    <>
      <Loading />
      {showMobileHeader && <MobileHeader />}
      <Box className={classes.container}>
        <Box className={classes.containerInner}>
          <Box className={classes.pageContent}>{children}</Box>
        </Box>
      </Box>
    </>
  );
};

ForecastingHeader.propTypes = {
  children: PropTypes.node.isRequired,
  navigationOpen: PropTypes.bool,
  disableDrawerMargin: PropTypes.bool,
  disableDrawerMarginOnMdDown: PropTypes.bool,
  showMobileHeader: PropTypes.bool,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForecastingHeader);
